export const patientId = (state) => state.patientId || '';

export const type = (state, getters) => getters.isSDMStarted ? 'SDM' : (getters.isFollowUpStarted  ? 'FOLLOWUP' : '');

export const isPatientDataAvailable = (
  state,
  getters,
  rootState,
  rootGetters
) =>
  !!(getters.patientId && getters.patientId === rootGetters['patientSummary/id']);

export const isSDMStarted = (state, getters, rootState, rootGetters) => {
  return !!rootGetters['patientSummary/getCurrentInProgressSDMEncounter'];
}

export const isFollowUpStarted = (state, getters, rootState, rootGetters) => {
  return getters.isPatientDataAvailable && !rootGetters['patientSummary/getCurrentInProgressSDMEncounter'];
}

export const isRecordOpened = (state) => {
  return !!state.patientId
}
